import * as React from 'react'
import { math } from '../utils/math'
import { useAnimationFrame } from './useAnimationFrame'
import { useBgm } from './useBgm'
import { useRecoilFreq } from './useRecoilFreq'
import { useRecoilSound } from './useRecoilSound'

export const useAYDAAudio = () => {
  const { sound } = useRecoilSound()
  const { setFreq } = useRecoilFreq()
  const { playBgm, analyser } = useBgm()
  const [count, setCount] = React.useState(0)

  useAnimationFrame(() => {
    setCount(count + 1)
    if (analyser && sound) {
      const bufferLength = analyser.frequencyBinCount
      const dataArray = new Uint8Array(bufferLength)
      analyser.getByteFrequencyData(dataArray)
      setFreq(dataArray)
    } else {
      const bufferLength = 128
      const dataArray = new Uint8Array(bufferLength)
      if (count % 20 === 0) {
        dataArray.fill(math.map(Math.random(), 0, 1, 255 * 0.7, 255))
      } else {
        dataArray.fill(math.map(Math.random(), 0, 1, 255 * 0, 255 * 0.1))
      }
      setFreq(dataArray)
    }
  })

  return { playBgm }
}
